import { render, staticRenderFns } from "./board-list-item-menu.vue?vue&type=template&id=b533c4f8&scoped=true&"
import script from "./board-list-item-menu.vue?vue&type=script&lang=js&"
export * from "./board-list-item-menu.vue?vue&type=script&lang=js&"
import style0 from "./board-list-item-menu.vue?vue&type=style&index=0&id=b533c4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b533c4f8",
  null
  
)

export default component.exports